import { ButtonV2 } from '@cimplico/components';
import { PencilIcon } from '@heroicons/react/20/solid';
import { toastNotification } from '../../../../components/toast/Toast';
import { useIsActiveSubscription } from '../../../../hooks/use-is-active-subscription';
import { useCreateResetPasswordUrl } from '../../../../queries/use-create-reset-password-url';
import SectionLabel from '../../../../components/section-label/SectionLabel';
import SettingsContainer from '../../../../components/settings-container/SettingsContainer';

function ChangePassword(): JSX.Element {
    const activeSubscription = useIsActiveSubscription();
    const resetPasswordQuery = useCreateResetPasswordUrl();

    function handleResetPassword(): void {
        resetPasswordQuery.mutate('', {
            onSuccess: ({ ticket }) => {
                window.open(ticket);
            },
            onError: () => {
                toastNotification('error', 'Unable to redirect to reset password page!');
            },
        });
    }

    return (
        <SettingsContainer>
            <SectionLabel title="Change password" description="Update the password associated with your Cimplico account." />
            {/* <div className="grid gap-8">
                <Input type="text" label="Current password" size="small" />
                <Input type="text" label="New password" size="small" />
                <Input type="text" label="Confirm password" size="small" />
                <Button label="Save" size="sm" leftIcon={<CheckIcon className="text-white" />} />
            </div> */}
            <div className="flex items-center">
                <ButtonV2
                    size="sm"
                    type="secondary"
                    label="Update Password"
                    onClick={handleResetPassword}
                    isDisabled={!activeSubscription}
                    leftIcon={<PencilIcon />}
                />
            </div>
        </SettingsContainer>
    );
}

export default ChangePassword;
